export default {
  title: 'Processing...',
  subtitle: 'You don\'t even have to lift a finger to do Kegel exercises!',
  text: 'For instance, you can literally do them while lying on a couch watching your favorite show'
}
